import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Search, X, Package } from 'lucide-react';
import { Input } from '../ui/input';
import { API, opts } from './equipmentMeta';

// Explicit Master Inventory match — the user must pick an item; nothing is matched by name.
export const InventoryItemPicker = ({ type, value, onChange, allowSearchAll = false, testid = 'inv-item-picker' }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      const params = q.trim() && allowSearchAll ? { q } : { type };
      axios.get(`${API}/inv/equipment-items`, { ...opts, params }).then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q, type, allowSearchAll]);

  if (value?.id) {
    return (
      <div data-testid={`${testid}-selected`} className="flex items-center justify-between gap-2 rounded-md border border-[#D4AF37]/50 bg-[#D4AF37]/10 px-2 py-1.5">
        <span className="text-xs text-white flex items-center gap-1.5 min-w-0"><Package className="w-3.5 h-3.5 text-[#D4AF37] shrink-0" /><span className="truncate">{value.name}{value.sku ? ` · ${value.sku}` : ''}</span></span>
        <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange(null)} className="text-[#A3A3A3] hover:text-white"><X className="w-3.5 h-3.5" /></button>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      {allowSearchAll && (
        <div className="relative">
          <Search className="w-3.5 h-3.5 text-[#737373] absolute left-2 top-1/2 -translate-y-1/2" />
          <Input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search Master Inventory by name, SKU, barcode"
            className="pl-7 h-8 text-xs bg-[#0A0A0A] border-[#262626] text-white" />
        </div>
      )}
      <div className="max-h-32 overflow-y-auto space-y-1">
        {items.length === 0 && <p className="text-[10px] text-[#737373]" data-testid={`${testid}-empty`}>{allowSearchAll ? 'No matching items.' : 'No inventory item mapped to this equipment type yet — the office can match it.'}</p>}
        {items.map((it) => (
          <button type="button" key={it.id} data-testid={`${testid}-opt-${it.id}`} onClick={() => onChange(it)}
            className="w-full text-left text-xs px-2 py-1 rounded border border-[#262626] text-[#A3A3A3] hover:text-white hover:border-[#404040]">
            {it.name}{it.sku ? ` · ${it.sku}` : ''}{it.barcode ? ` · ${it.barcode}` : ''}
          </button>
        ))}
      </div>
    </div>
  );
};

export default InventoryItemPicker;
